import React, { PropTypes } from 'react';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';

const GbpModalHeader = ((props) => {
  const { onToggleModal } = props;
  return (
    <header>
      <Row>
        <Col md='12'>
          <i className='material-icons pointer mui--pull-right' style={ { fontSize: '24px' } } onClick={ onToggleModal }>clear</i>
          <div className='mui--clearfix' />
        </Col>
      </Row>
    </header>
  );
});

GbpModalHeader.propTypes = {
  onToggleModal: PropTypes.func.isRequired,
};

export default GbpModalHeader;
